import { StudentProblemResult } from '@yandex-int/k-common/typings';

export function getOpenAnswerUrl(problemResult: StudentProblemResult | null): string | null {
    const rawMarkerSpecificData = problemResult?.marker_specific_data || null;

    if (!rawMarkerSpecificData) {
        return null;
    }

    // @ts-ignore
    return Object.values(rawMarkerSpecificData)[0]?.url || null;
}

export function getOpenAnswerCheckId(problemResult: StudentProblemResult | null): string | null {
    const rawMarkerSpecificData = problemResult?.marker_specific_data || null;

    if (!rawMarkerSpecificData) {
        return null;
    }

    // @ts-ignore
    return Object.values(rawMarkerSpecificData)[0]?.check_uuid || null;
}

// id попытки для оценивания учителем (проставления критериев)
export function getOpenAnswerAttemptId(
    studentProblemResult: StudentProblemResult | null,
    problemLinkId: number,
    studentId?: number | null
) {
    const hasAttempt = Boolean(getOpenAnswerUrl(studentProblemResult));
    if (!hasAttempt) {
        return null;
    }
    // для открытого ответа (маркера diskurl) добавляется uuid попытки на беке
    let attemptId = getOpenAnswerCheckId(studentProblemResult);
    if (!attemptId && studentId) {
        // если uuid нету (попытка до 07.02.2022), то берем id ученика и id lpl
        attemptId = `${studentId}:${problemLinkId}`;
    }
    return attemptId;
}
